<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="close()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="text-h5 font-weight-regular pb-4">
                {{ $t("accounts.deleteAccount") }}
              </h1>
              <p class="py-5">
                {{ $t("accounts.deleteAccountMessage") }}
              </p>
              <v-row>
                <v-col>
                  <label class="second-type-label">{{ $t("accounts.accountNumber") }}</label>
                  <p class="font-weight-medium">{{ account.iban }}</p>
                </v-col>
                <v-col>
                  <label class="second-type-label">{{ $t("accounts.description") }}</label>
                  <p class="font-weight-medium">{{ account.description }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          :color="entityConfig.primaryColor"
          @click="$emit('closed')"
          class="v-btn-width-default"
        >
          {{ $t("accounts.goBack") }}
        </v-btn>
        <v-btn
          dark
          depressed
          class="v-btn-width-default"
          :color="entityConfig.primaryColor"
          :style="`color: ${entityConfig.secondaryColor}`"
          @click="delete_account"
        >
          {{ $t("accounts.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <overlay :visible="spinner" :opacity="1"></overlay>
  </v-dialog>
</template>

<script>
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
export default {
  props: ["account", "visible"],
  components: {
    Overlay,
  },
  data() {
    return {
      entityConfig: {},
      userId: "",
      userdata: {},
      spinner: false,
      model: {
        iban: "",
        description: "",
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");

    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();
    this.model.iban = this.account.iban;
    this.model.description = this.account.description;
  },
  methods: {
    close() {
      this.$emit("closed");
    },
    save(data) {
      this.$emit("saved", data);
    },

    async delete_account() {
      let message = "Su cuenta fue eliminada de forma exitosa";
      try {
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.account.iban);
        formData.append("description", this.model.description);
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.fromEntries(formData);
        await Api.delete(
          `/proveedores/${this.userId}/cuentas-abono/${this.account.iban}`,
          obj
        );
        this.spinner = false;
        this.$emit("closed");
        this.$toast.success(message);
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
